/**
 * @desc 财务画像-历史处罚-深圳证券交易所
 * @author caoyx
 */
import React, { PureComponent } from 'react';
import GroupBox from '../../../common/groupBox/GroupBox';
import Pagination from '../../../common/pagination/Pagination';
import {commonRequest} from '../../common/commons';
import {addDataIndex, isNotEmpty} from '../../../../utils/util';
import {Table} from 'antd';
import {szseDegree, szsePunish, szseEnquiry, szseMeasures} from './columns';
import {getSZSEDegree, getSZSEEnquiry, getSZSEMeasures, getSZSPunish} from '../../../../services/financialPicture/historyPunish';

export default class SZSE extends PureComponent {
    constructor(props) {
        super(props);
        this.szseNav = [];
        this.state = {
            loading: true,
            degreePageSize: 10,
            degreePageNum: 1,
            degreeTotal: 0,
            degree: [],
            punishPageSize: 10,
            punishPageNum: 1,
            punishTotal: 0,
            punish: [],
            enquiryPageSize: 10,
            enquiryPageNum: 1,
            enquiryTotal: 0,
            enquiry: [],
            measuresPageSize: 10,
            measuresPageNum: 1,
            measuresTotal: 0,
            measures: []
        };
    }

    componentDidMount() {
        this.getDegreeData();
        this.getPunishData();
        this.getEnquiryData();
        this.getMeasuresData();
    }

    szseProps = () => {
        const {degree, punish, enquiry, measures} = this.state;
        const { subNav } = this.props;
        let szseSubNav = [];
        if(isNotEmpty(degree) || isNotEmpty(punish) || isNotEmpty(enquiry) || isNotEmpty(measures)) {
            szseSubNav = [
                {id: 'szse-promise', name: '深圳证券交易所-承诺事项及履行情况'},
                {id: 'szse-punish', name: '深圳证券交易所-处罚与处分记录'},
                {id: 'szse-enquiry-letters', name: '深圳证券交易所-问询函件'},
                {id: 'szse-adminis-measures', name: '深圳证券交易所-监管措施'}
            ];
            this.szseNav = szseSubNav;
        } else {
            szseSubNav = [];
        }
        subNav && subNav(szseSubNav);
    }
    
    // 深圳证券交易所-承诺事项及履行情况
    getDegreeData = () => {
        const { degreePageNum, degreePageSize } = this.state;
        this.setState({
            loading: true
        });
        getSZSEDegree(commonRequest({ pageNum: degreePageNum, pageSize: degreePageSize })).then(data => {
            data = data || {};
            this.setState({
                loading: false,
                degree: addDataIndex(data.results, degreePageNum, degreePageSize),
                degreeTotal: data.total
            }, () => {
                this.szseProps();
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    // 深圳证券交易所-处罚与处分记录
    getPunishData = () => {
        const { punishPageNum, punishPageSize } = this.state;
        getSZSPunish(commonRequest({ pageNum: punishPageNum, pageSize: punishPageSize })).then(data => {
            data = data || {};
            this.setState({
                punish: addDataIndex(data.results, punishPageNum, punishPageSize),
                punishTotal: data.total
            }, () => {
                this.szseProps();
            });
        }).catch(() => {
            this.setState({
                punish: []
            });
        });
    };

    // 深圳证券交易所-问询函件
    getEnquiryData = () => {
        const { enquiryPageNum, enquiryPageSize } = this.state;
        getSZSEEnquiry(commonRequest({ pageNum: enquiryPageNum, pageSize: enquiryPageSize })).then(data => {
            data = data || {};
            this.setState({
                enquiry: addDataIndex(data.results, enquiryPageNum, enquiryPageSize),
                enquiryTotal: data.total
            }, () => {
                this.szseProps();
            });
        }).catch(() => {
            this.setState({
                enquiry: []
            });
        });
    };

    // 深圳证券交易所-监管措施
    getMeasuresData = () => {
        const { measuresPageNum, measuresPageSize } = this.state;
        getSZSEMeasures(commonRequest({ pageNum: measuresPageNum, pageSize: measuresPageSize })).then(data => {
            data = data || {};
            this.setState({
                measures: addDataIndex(data.results, measuresPageNum, measuresPageSize),
                measuresTotal: data.total
            }, () => {
                this.szseProps();
            });
        }).catch(() => {
            this.setState({
                measures: []
            });
        });
    };

    // 分页
    pageChange = (degreePageNum, degreePageSize) => {
        this.setState({
            degreePageNum,
            degreePageSize
        }, () => {
            this.getDegreeData();
        });
    };

    measuresChange = (measuresPageNum, measuresPageSize) => {
        this.setState({
            measuresPageNum,
            measuresPageSize
        }, () => {
            this.getMeasuresData();
        });
    };

    enquiryChange = (enquiryPageNum, enquiryPageSize) => {
        this.setState({
            enquiryPageNum,
            enquiryPageSize
        }, () => {
            this.getEnquiryData();
        });
    };

    punishChange = (punishPageNum, punishPageSize) => {
        this.setState({
            punishPageNum,
            punishPageSize
        }, () => {
            this.getPunishData();
        });
    };

    render() {
        const { degreePageSize, degreePageNum, degreeTotal, degree, loading,
            punishPageSize, punishPageNum, punishTotal, punish,
            enquiryPageSize, enquiryPageNum, enquiryTotal, enquiry,
            measuresPageSize, measuresPageNum, measuresTotal, measures
        } = this.state;
        return (
            <div>
                {isNotEmpty(this.szseNav) ? 
                    <div>
                        <GroupBox id={'szse-promise'} title={'深圳证券交易所-承诺事项及履行情况'}>
                            <Table
                                pagination={false}
                                loading={loading}
                                bordered
                                rowKey="index"
                                dataSource={degree}
                                columns={szseDegree}
                                footer={() => degreeTotal > 10 ? <Pagination total={degreeTotal} current={degreePageNum} pageSize={degreePageSize} onChange={this.pageChange} /> : null}
                            />
                        </GroupBox>
                        <GroupBox id={'szse-punish'} title={'深圳证券交易所-处罚与处分记录'}>
                            <Table
                                pagination={false}
                                bordered
                                rowKey="index"
                                dataSource={punish}
                                columns={szsePunish}
                                footer={() => punishTotal > 10 ? <Pagination total={punishTotal} current={punishPageNum} pageSize={punishPageSize} onChange={this.punishChange} /> : null}
                            />
                        </GroupBox>
                        <GroupBox id={'szse-enquiry-letters'} title={'深圳证券交易所-问询函件'}>
                            <Table
                                pagination={false}
                                bordered
                                rowKey="index"
                                dataSource={enquiry}
                                columns={szseEnquiry}
                                footer={() => enquiryTotal > 10 ? <Pagination total={enquiryTotal} current={enquiryPageNum} pageSize={enquiryPageSize} onChange={this.enquiryChange} /> : null}
                            />
                        </GroupBox>
                        <GroupBox id={'szse-adminis-measures'} title={'深圳证券交易所-监管措施'}>
                            <Table
                                pagination={false}
                                bordered
                                rowKey="index"
                                dataSource={measures}
                                columns={szseMeasures}
                                footer={() => measuresTotal > 10 ? <Pagination total={measuresTotal} current={measuresPageNum} pageSize={measuresPageSize} onChange={this.measuresChange} /> : null}
                            />
                        </GroupBox>
                    </div> : ''
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/historyPunishment/subComponents/SZSE.jsx